import { DynamicSvgIcon } from '@components/ui'

import { Database_Procs_GetPlayerQuest_Item } from '@suntex.fim/api-client'

interface MyQuestCarouselItemProps {
  quest: Database_Procs_GetPlayerQuest_Item
}

const MyQuestCarouselItem = ({ quest }: MyQuestCarouselItemProps) => (
  <div className="my-quest-carousel__item">
    <DynamicSvgIcon quest={quest} style={{ margin: 'auto' }} />
    <p>{quest.questName}</p>
  </div>
)

export default MyQuestCarouselItem
